import { render, staticRenderFns } from "./CustomerSignAgain.vue?vue&type=template&id=3afad4e2&"
import script from "./CustomerSignAgain.vue?vue&type=script&lang=js&"
export * from "./CustomerSignAgain.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSignAgain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports